import { createSelector } from 'reselect';

// QUESTION SETS SELECTOR
export const questionSetsSelector = (state) => state.questionSets;

// GET QUESTION SETS SELECTOR
export const getQuestionSetsSelectorSelector = createSelector(
  [questionSetsSelector],
  ({ data }) => data
);

export const selectGeneratedQuestionSet = createSelector(
  [questionSetsSelector],
  ({ generatedQuestionSet }) => generatedQuestionSet
);

export const selectIsGenerating = createSelector(
  [questionSetsSelector],
  ({ isGenerating }) => isGenerating
);

export const selectGeneratedQuestionSetError = createSelector(
  [questionSetsSelector],
  ({ generatedQuestionSetError }) => generatedQuestionSetError
);
